import { toast } from "react-toastify";
import { observable, runInAction } from "mobx";
import { api, apiOperacao } from "../../api";
import { NFesStore } from "../nfe/NFesStore";
import { decodeUtf8String, downloadBinaryFile } from "../../utils";
import * as moment from "moment";

export class _TarefasStore {
  obs = observable({
    tasks_nfses: [] as any[],
    length_tasks_nfses: 0 as number,
    programar_nfses: false as boolean,
    open_detalhes_nfses: false as boolean,
    loading: false as boolean,
    
    selectedTab: "notas" as string,

  })

  async handleTasksPaged(paged: number) {

    let data = {
      page: paged,
      limit: 15,
      cnpj: NFesStore.obs.selectedEmpresa.cnpj,
    }

    try {

      let resp = await apiOperacao("notas_xml").post("/notas_xml/danfe-task-index", data);

      runInAction(() => {
        this.obs.tasks_nfses = [];
        this.obs.length_tasks_nfses = 0

        if (resp.data.itens.length > 0) {
          this.obs.tasks_nfses = resp.data.itens;
          this.obs.length_tasks_nfses = resp.data.count
        }
      });

    } catch (ex) { }

  }

  async handleDownloadArquivoNfse(row: any) {
    TarefasStore.obs.loading = true

    try {

      let resp = await apiOperacao("notas_xml").get(`/notas_xml/danfe-task-download/${row.id}`,
          { responseType: "blob" }
        );

      if (resp.status == 200) {

        row.data1 = moment(row.date_start).format("DD-MM-YYYY")
        row.data2 = moment(row.date_end).format("DD-MM-YYYY")

        const razao_social = row.razao_social.replace(/\ /g, "_")

        const name = `${razao_social}-${row.cnpj}-${row.data1}-${row.data2}.zip`

        downloadBinaryFile(resp.data, name)

      } else {

        toast.error(decodeUtf8String(resp.headers.msg), {});

      }

    } catch (ex) { }

    TarefasStore.obs.loading = false

  }

  
}

export const TarefasStore = new _TarefasStore();
